export enum SearchTagsType {
  CONTAIN = 'Contain',
  CONTAIN_ONE_OF = 'Contain one of',
  DOESNT_CONTAIN = "Doesn't contain"
}


export enum TagType {
  TAG = 'tag',
  STATUS = 'status',
  AI = 'ai'
}